import GroupStatusColumn from './GroupStatusColumn';

export default GroupStatusColumn;
